export default __webpack_public_path__ + "assets/images/4dd8ccfbda7178e4b416a61b53ff3fdd.png";